import { create } from 'zustand'

interface SessionUser {
  actor: string
  role: string
  audience: string
  expires_at: string
  // Rechte der Rolle aus /auth/me bzw. Login ("*" = alle); fehlt = unbekannt
  permissions?: string[]
}

interface AuthState {
  user: SessionUser | null
  setupCompleted: boolean | null
  licenseFeatures: Record<string, boolean>
  setUser: (u: SessionUser | null) => void
  setSetupCompleted: (v: boolean) => void
  setLicenseFeatures: (m: Record<string, boolean>) => void
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  setupCompleted: null,
  licenseFeatures: {},
  setUser: (u) => set({ user: u }),
  setSetupCompleted: (v) => set({ setupCompleted: v }),
  setLicenseFeatures: (m) => set({ licenseFeatures: m }),
}))

export type { SessionUser }
